import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=bfc18338"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=bfc18338&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports